// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inputLabelFloat {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
}

.inputLabelFloat input:read-only,
.inputLabelFloat.date input,
.inputLabelFloat.date label {
  cursor: pointer;
}

.inputLabelFloat label {
  position: absolute;
  left: 1rem;
  top: 0rem;
  color: var(--clr-gray400);
  font-size: 0.9rem;
  font-weight: 400;
  letter-spacing: 0.05rem;
  margin: 0.5rem 0;
  cursor: text;
  z-index: 1;
}

.inputLabelFloat__counter {
  display: flex;
  width: 100%;
  max-width: 7rem;
  gap: 0.5rem;
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;
}

.inputLabelFloat__counter .btn-add,
.inputLabelFloat__counter .btn-minus {
  height: 1rem !important;
}

.inputLabelFloat__counter span {
  font-weight: bold;
}

/* .inputIcon {
        position: absolute;
        left: 1rem;
        top: 50%;
        transform: translateY(-50%);
      } */

.inputLabelFloat input::placeholder {
  letter-spacing: 0.05rem;
}

.inputLabelFloat__inputCounterContainer,
.inputLabelFloat input {
  display: flex;
  align-items: center;
  width: 100%;
  font-weight: 400;
  padding: 1em 1.25em;
  border-radius: 1em;
  letter-spacing: 0.05rem;
  border: 0.15rem solid var(--clr-gray300);
  font-size: 12.8px;
  padding-top: 2em;
  padding-bottom: 0.65em;
  outline: none;
  background: var(--clr-gray300);
}

.inputLabelFloat input:focus {
  border: 0.15rem solid var(--clr-dark);
  background: var(--clr-light);
}

.inputLabelFloat input::placeholder {
  color: transparent;
}

.inputLabelFloat input:focus::placeholder {
  color: var(--clr-gray400);
}

.inputLabelFloat input:focus ~ label {
  color: var(--clr-gray600);
}

.inputLabelFloat input:placeholder-shown ~ label {
  top: 0.6rem;
}

.inputLabelFloat__inputCounterContainer label,
.inputLabelFloat input:focus ~ label {
  top: 0rem;
  left: 1em;
  /* font-size: 12px; */
  /* background: #fff; */
  font-size: 0.8rem;
  padding: 0.25em 0.5em;
  text-align: center;
  transition: all 0.5s;
}

.inputLabelFloat input:-webkit-autofill,
.inputLabelFloat input:-webkit-autofill:hover,
.inputLabelFloat input:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0px 1000px #fff inset;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}

.inputLabelFloat__iconClose {
  display: flex;
  right: 1rem;
  width: 1rem;
  cursor: pointer;
  pointer-events: all;
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
}

.inputLabelFloat input:focus ~ .inputLabelFloat__iconClose {
  pointer-events: all;
  display: flex;
}

.inputLabelFloat input:placeholder-shown ~ .inputLabelFloat__iconClose {
  display: none;
  pointer-events: none;
}

.inputLabelFloat__suggestions {
  position: absolute;
  background: var(--clr-gray300);
  max-height: 10rem;
  overflow-y: scroll;
  top: calc(100% + 0.5rem);
  padding: 1em 0;
  scrollbar-width: thin;
  scrollbar-track-color: transparent;
  border-radius: 1em;
  width: 100%;
  z-index: 10;
  box-shadow: 0 0.5rem 1rem #0009;
}

.inputLabelFloat__suggestions::-webkit-scrollbar {
  width: 0.75rem;
}

.inputLabelFloat__suggestions::-webkit-scrollbar-track {
  background-color: transparent;
}

.inputLabelFloat__suggestions::-webkit-scrollbar-thumb {
  background: var(--clr-primary-dark);
  border-radius: 3rem;
}

.inputLabelFloat__suggestions li {
  padding: 0.65em 1.25em;
  font-size: 0.8rem;
  cursor: pointer;
  transition: 0.25s;
  font-weight: 500;
  background: transparent;
}

.inputLabelFloat__suggestions li:hover {
  /* background: var(--clr-gray400); */
  font-weight: 700;
  color: var(--clr-primary);
}

@media (min-width: 992px) {
  .inputLabelFloat__suggestions {
    top: calc(100% + 1rem);
    box-shadow: 0 0.5rem 1rem #0002;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/InputLabelFloat/InputLabelFloat.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,WAAW;EACX,cAAc;EACd,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;SAKS;;AAET;EACE,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,SAAS;EACT,SAAS;EACT,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;;EAGE,6CAA6C;EAC7C,yDAAiD;EAAjD,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,WAAW;EACX,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;EACd,qBAAqB;EACrB,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE;IACE,sBAAsB;IACtB,+BAA+B;EACjC;AACF","sourcesContent":[".inputLabelFloat {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  position: relative;\n}\n\n.inputLabelFloat input:read-only,\n.inputLabelFloat.date input,\n.inputLabelFloat.date label {\n  cursor: pointer;\n}\n\n.inputLabelFloat label {\n  position: absolute;\n  left: 1rem;\n  top: 0rem;\n  color: var(--clr-gray400);\n  font-size: 0.9rem;\n  font-weight: 400;\n  letter-spacing: 0.05rem;\n  margin: 0.5rem 0;\n  cursor: text;\n  z-index: 1;\n}\n\n.inputLabelFloat__counter {\n  display: flex;\n  width: 100%;\n  max-width: 7rem;\n  gap: 0.5rem;\n  margin: 0 auto;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.inputLabelFloat__counter .btn-add,\n.inputLabelFloat__counter .btn-minus {\n  height: 1rem !important;\n}\n\n.inputLabelFloat__counter span {\n  font-weight: bold;\n}\n\n/* .inputIcon {\n        position: absolute;\n        left: 1rem;\n        top: 50%;\n        transform: translateY(-50%);\n      } */\n\n.inputLabelFloat input::placeholder {\n  letter-spacing: 0.05rem;\n}\n\n.inputLabelFloat__inputCounterContainer,\n.inputLabelFloat input {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  font-weight: 400;\n  padding: 1em 1.25em;\n  border-radius: 1em;\n  letter-spacing: 0.05rem;\n  border: 0.15rem solid var(--clr-gray300);\n  font-size: 12.8px;\n  padding-top: 2em;\n  padding-bottom: 0.65em;\n  outline: none;\n  background: var(--clr-gray300);\n}\n\n.inputLabelFloat input:focus {\n  border: 0.15rem solid var(--clr-dark);\n  background: var(--clr-light);\n}\n\n.inputLabelFloat input::placeholder {\n  color: transparent;\n}\n\n.inputLabelFloat input:focus::placeholder {\n  color: var(--clr-gray400);\n}\n\n.inputLabelFloat input:focus ~ label {\n  color: var(--clr-gray600);\n}\n\n.inputLabelFloat input:placeholder-shown ~ label {\n  top: 0.6rem;\n}\n\n.inputLabelFloat__inputCounterContainer label,\n.inputLabelFloat input:focus ~ label {\n  top: 0rem;\n  left: 1em;\n  /* font-size: 12px; */\n  /* background: #fff; */\n  font-size: 0.8rem;\n  padding: 0.25em 0.5em;\n  text-align: center;\n  transition: all 0.5s;\n}\n\n.inputLabelFloat input:-webkit-autofill,\n.inputLabelFloat input:-webkit-autofill:hover,\n.inputLabelFloat input:-webkit-autofill:focus {\n  -webkit-box-shadow: 0 0 0px 1000px #fff inset;\n  transition: background-color 5000s ease-in-out 0s;\n}\n\n.inputLabelFloat__iconClose {\n  display: flex;\n  right: 1rem;\n  width: 1rem;\n  cursor: pointer;\n  pointer-events: all;\n  top: 50%;\n  transform: translateY(-50%);\n  position: absolute;\n}\n\n.inputLabelFloat input:focus ~ .inputLabelFloat__iconClose {\n  pointer-events: all;\n  display: flex;\n}\n\n.inputLabelFloat input:placeholder-shown ~ .inputLabelFloat__iconClose {\n  display: none;\n  pointer-events: none;\n}\n\n.inputLabelFloat__suggestions {\n  position: absolute;\n  background: var(--clr-gray300);\n  max-height: 10rem;\n  overflow-y: scroll;\n  top: calc(100% + 0.5rem);\n  padding: 1em 0;\n  scrollbar-width: thin;\n  scrollbar-track-color: transparent;\n  border-radius: 1em;\n  width: 100%;\n  z-index: 10;\n  box-shadow: 0 0.5rem 1rem #0009;\n}\n\n.inputLabelFloat__suggestions::-webkit-scrollbar {\n  width: 0.75rem;\n}\n\n.inputLabelFloat__suggestions::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n\n.inputLabelFloat__suggestions::-webkit-scrollbar-thumb {\n  background: var(--clr-primary-dark);\n  border-radius: 3rem;\n}\n\n.inputLabelFloat__suggestions li {\n  padding: 0.65em 1.25em;\n  font-size: 0.8rem;\n  cursor: pointer;\n  transition: 0.25s;\n  font-weight: 500;\n  background: transparent;\n}\n\n.inputLabelFloat__suggestions li:hover {\n  /* background: var(--clr-gray400); */\n  font-weight: 700;\n  color: var(--clr-primary);\n}\n\n@media (min-width: 992px) {\n  .inputLabelFloat__suggestions {\n    top: calc(100% + 1rem);\n    box-shadow: 0 0.5rem 1rem #0002;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
